var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 77.55 94.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:url(#radial-gradient);}.cls-3{opacity:0.17;}.cls-4{fill:#320f32;}.cls-5{fill:#673434;}.cls-6{fill:#650a34;}.cls-7{fill:#19331a;}.cls-8{fill:#b2d39b;}.cls-9{fill:url(#radial-gradient-2);}.cls-10{fill:url(#radial-gradient-3);}.cls-11{fill:url(#radial-gradient-4);}.cls-12{fill:url(#radial-gradient-5);}.cls-13{fill:url(#radial-gradient-6);}.cls-14{fill:url(#radial-gradient-7);}.cls-15{fill:url(#radial-gradient-8);}.cls-16{fill:url(#radial-gradient-9);}.cls-17{fill:url(#radial-gradient-10);}.cls-18{fill:url(#radial-gradient-11);}.cls-19{fill:url(#radial-gradient-12);}.cls-20{fill:url(#radial-gradient-13);}.cls-21{fill:url(#radial-gradient-14);}.cls-22{fill:url(#radial-gradient-15);}.cls-23{fill:url(#radial-gradient-16);}.cls-24{fill:url(#radial-gradient-17);}.cls-25{fill:url(#radial-gradient-18);}.cls-26{fill:url(#radial-gradient-19);}.cls-27{fill:url(#radial-gradient-20);}.cls-28{fill:url(#radial-gradient-21);}.cls-29{fill:url(#radial-gradient-22);}.cls-30{fill:url(#radial-gradient-23);}.cls-31{fill:url(#radial-gradient-24);}.cls-32{fill:url(#radial-gradient-25);}.cls-33{fill:url(#radial-gradient-26);}.cls-34{fill:url(#radial-gradient-27);}.cls-35{fill:url(#radial-gradient-28);}.cls-36{fill:url(#radial-gradient-29);}.cls-37{fill:url(#radial-gradient-30);}.cls-38{fill:url(#radial-gradient-31);}.cls-39{fill:url(#radial-gradient-32);}.cls-40{fill:url(#radial-gradient-33);}.cls-41{fill:url(#radial-gradient-34);}.cls-42{fill:url(#radial-gradient-35);}.cls-43{fill:url(#radial-gradient-36);}.cls-44{fill:url(#radial-gradient-37);}.cls-45{fill:url(#radial-gradient-38);}.cls-46{fill:url(#radial-gradient-39);}.cls-47{fill:url(#radial-gradient-40);}.cls-48{fill:url(#radial-gradient-41);}.cls-49{fill:url(#radial-gradient-42);}.cls-50{fill:url(#radial-gradient-43);}.cls-51{fill:url(#radial-gradient-44);}.cls-52{fill:url(#radial-gradient-45);}.cls-53{fill:url(#radial-gradient-46);}.cls-54{fill:url(#radial-gradient-47);}.cls-55{fill:url(#radial-gradient-48);}.cls-56{fill:url(#radial-gradient-49);}.cls-57{fill:url(#radial-gradient-50);}.cls-58{fill:url(#radial-gradient-51);}.cls-59{fill:url(#radial-gradient-52);}.cls-60{fill:url(#radial-gradient-53);}.cls-61{fill:url(#radial-gradient-54);}.cls-62{fill:url(#radial-gradient-55);}.cls-63{fill:url(#radial-gradient-56);}.cls-64{fill:url(#radial-gradient-57);}.cls-65{fill:url(#radial-gradient-58);}.cls-66{fill:url(#radial-gradient-59);}.cls-67{fill:url(#radial-gradient-60);}.cls-68{fill:url(#radial-gradient-61);}.cls-69{fill:url(#radial-gradient-62);}.cls-70{fill:url(#radial-gradient-63);}.cls-71{fill:url(#radial-gradient-64);}.cls-72{fill:url(#radial-gradient-65);}.cls-73{fill:url(#radial-gradient-66);}.cls-74{fill:url(#radial-gradient-67);}.cls-75{fill:url(#radial-gradient-68);}.cls-76{fill:url(#radial-gradient-69);}.cls-77{fill:url(#radial-gradient-70);}.cls-78{fill:url(#radial-gradient-71);}.cls-79{fill:url(#radial-gradient-72);}.cls-80{fill:url(#radial-gradient-73);}.cls-81{fill:url(#radial-gradient-74);}.cls-82{fill:url(#radial-gradient-75);}.cls-83{fill:url(#radial-gradient-76);}.cls-84{fill:url(#radial-gradient-77);}.cls-85{fill:url(#radial-gradient-78);}.cls-86{fill:url(#radial-gradient-79);}.cls-87{fill:url(#radial-gradient-80);}.cls-88{fill:url(#radial-gradient-81);}.cls-89{fill:url(#radial-gradient-82);}.cls-90{fill:url(#radial-gradient-83);}.cls-91{fill:url(#radial-gradient-84);}.cls-92{fill:url(#radial-gradient-85);}.cls-93{fill:url(#radial-gradient-86);}.cls-94{fill:url(#radial-gradient-87);}.cls-95{fill:url(#radial-gradient-88);}.cls-96{fill:url(#radial-gradient-89);}.cls-97{fill:url(#radial-gradient-90);}.cls-98{fill:url(#radial-gradient-91);}.cls-99{fill:url(#radial-gradient-92);}.cls-100{fill:url(#radial-gradient-93);}.cls-101{fill:url(#radial-gradient-94);}.cls-102{fill:url(#radial-gradient-95);}.cls-103{fill:url(#radial-gradient-96);}.cls-104{fill:url(#radial-gradient-97);}.cls-105{fill:url(#radial-gradient-98);}.cls-106{fill:url(#radial-gradient-99);}.cls-107{fill:url(#radial-gradient-100);}.cls-108{fill:url(#radial-gradient-101);}.cls-109{fill:url(#radial-gradient-102);}.cls-110{fill:url(#radial-gradient-103);}.cls-111{fill:url(#radial-gradient-104);}.cls-112{fill:url(#radial-gradient-105);}.cls-113{fill:url(#radial-gradient-106);}.cls-114{fill:url(#radial-gradient-107);}.cls-115{fill:url(#radial-gradient-108);}.cls-116{fill:url(#radial-gradient-109);}.cls-117{fill:url(#radial-gradient-110);}.cls-118{fill:url(#radial-gradient-111);}.cls-119{fill:url(#radial-gradient-112);}.cls-120{fill:url(#radial-gradient-113);}.cls-121{fill:url(#radial-gradient-114);}.cls-122{fill:url(#radial-gradient-115);}.cls-123{fill:url(#radial-gradient-116);}.cls-124{fill:url(#radial-gradient-117);}.cls-125{fill:url(#radial-gradient-118);}.cls-126{fill:url(#radial-gradient-119);}.cls-127{fill:url(#radial-gradient-120);}.cls-128{fill:url(#radial-gradient-121);}.cls-129{fill:url(#radial-gradient-122);}.cls-130{fill:url(#radial-gradient-123);}.cls-131{fill:url(#radial-gradient-124);}.cls-132{fill:url(#radial-gradient-125);}.cls-133{fill:url(#radial-gradient-126);}.cls-134{fill:url(#radial-gradient-127);}.cls-135{fill:url(#radial-gradient-128);}.cls-136{fill:url(#radial-gradient-129);}.cls-137{fill:url(#radial-gradient-130);}.cls-138{fill:url(#radial-gradient-131);}.cls-139{fill:url(#radial-gradient-132);}.cls-140{fill:url(#radial-gradient-133);}.cls-141{fill:url(#radial-gradient-134);}.cls-142{fill:url(#radial-gradient-135);}.cls-143{fill:url(#radial-gradient-136);}.cls-144{fill:url(#radial-gradient-137);}.cls-145{fill:url(#radial-gradient-138);}.cls-146{fill:url(#radial-gradient-139);}.cls-147{fill:url(#radial-gradient-140);}.cls-148{fill:url(#radial-gradient-141);}.cls-149{fill:url(#radial-gradient-142);}.cls-150{fill:url(#radial-gradient-143);}.cls-151{fill:url(#radial-gradient-144);}.cls-152{fill:#333;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 37.84,
    cy: -131.44,
    r: 38.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#227a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669940"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 44.54,
    cy: -121.34,
    r: 3.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -90.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669940"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 48.66,
    cy: -129.46,
    r: 3.59,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 42.16,
    cy: -128.32,
    r: 3.07,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 49.31,
    cy: -146.59,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 50.51,
    cy: -146.02,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 51.67,
    cy: -145.36,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 52.79,
    cy: -144.64,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 53.85,
    cy: -143.84,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 54.86,
    cy: -142.97,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 56.7,
    cy: -141.06,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 57.53,
    cy: -140.02,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 58.28,
    cy: -138.92,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 58.96,
    cy: -137.78,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 59.57,
    cy: -136.59,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 60.1,
    cy: -135.37,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 60.55,
    cy: -134.12,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 60.91,
    cy: -132.84,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 61.2,
    cy: -131.54,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 61.4,
    cy: -130.23,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 61.5,
    cy: -128.9,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 61.47,
    cy: -126.24,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 61.32,
    cy: -124.92,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 61.09,
    cy: -123.61,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 60.77,
    cy: -122.32,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 60.37,
    cy: -121.05,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 59.88,
    cy: -119.81,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 59.32,
    cy: -118.6,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 58.69,
    cy: -117.44,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 57.97,
    cy: -116.31,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 57.19,
    cy: -115.23,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 55.42,
    cy: -113.25,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 54.44,
    cy: -112.35,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 53.41,
    cy: -111.51,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 52.32,
    cy: -110.75,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 51.18,
    cy: -110.05,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 50.01,
    cy: -109.44,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 48.79,
    cy: -108.9,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 47.54,
    cy: -108.43,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 46.27,
    cy: -108.05,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 43.66,
    cy: -107.54,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 42.34,
    cy: -107.41,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 41.01,
    cy: -107.37,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 39.67,
    cy: -107.41,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 38.35,
    cy: -107.55,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 37.04,
    cy: -107.77,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 35.75,
    cy: -108.07,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 34.47,
    cy: -108.46,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 33.3,
    cy: -109.59,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 32.8,
    cy: -110.83,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 32.37,
    cy: -112.09,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 31.95,
    cy: -113.36,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 31.62,
    cy: -114.65,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 31.32,
    cy: -115.94,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 31.09,
    cy: -117.26,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 30.92,
    cy: -118.57,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 30.79,
    cy: -119.9,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 30.77,
    cy: -121.24,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 30.79,
    cy: -122.56,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 30.88,
    cy: -123.89,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 31.06,
    cy: -125.22,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 31.31,
    cy: -126.52,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 31.63,
    cy: -127.82,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 32.47,
    cy: -130.34,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 33,
    cy: -131.57,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 33.58,
    cy: -132.76,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 34.22,
    cy: -133.93,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: 34.92,
    cy: -135.06,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 35.67,
    cy: -136.16,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 36.48,
    cy: -137.22,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 37.33,
    cy: -138.24,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 38.22,
    cy: -139.23,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 39.15,
    cy: -140.19,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 40.11,
    cy: -141.11,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 41.11,
    cy: -142,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: 42.14,
    cy: -142.84,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 43.19,
    cy: -143.65,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 44.27,
    cy: -144.43,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 45.38,
    cy: -145.17,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 46.51,
    cy: -145.87,
    r: 0.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-81",
    cx: 33.77,
    cy: -108.72,
    r: 0,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-82",
    cx: 48.33,
    cy: -147.26,
    r: 0.01,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-83",
    cx: 33.79,
    cy: -157.97,
    r: 3.96,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-84",
    cx: 32.73,
    cy: -154.8,
    r: 3.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-85",
    cx: 31.71,
    cy: -152.13,
    r: 3.24,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-86",
    cx: 30.93,
    cy: -150.08,
    r: 2.54,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-87",
    cx: 30.23,
    cy: -148.24,
    r: 1.78,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-88",
    cx: 29.54,
    cy: -146.51,
    r: 0.93,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-89",
    cx: 28.21,
    cy: -143.31,
    r: 1.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-90",
    cx: 27.38,
    cy: -141.28,
    r: 2.44,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-91",
    cx: 26.32,
    cy: -138.79,
    r: 3.01,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-92",
    cx: 25,
    cy: -135.82,
    r: 3.32,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-93",
    cx: 23.64,
    cy: -132.65,
    r: 3.32,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: 22.31,
    cy: -129.68,
    r: 3.01,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-95",
    cx: 21.23,
    cy: -127.1,
    r: 2.45,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-96",
    cx: 20.34,
    cy: -125.13,
    r: 1.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-97",
    cx: 19.48,
    cy: -123.34,
    r: 0.91,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-98",
    cx: 18.4,
    cy: -120.23,
    r: 1.78,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-99",
    cx: 17.7,
    cy: -118.4,
    r: 2.53,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-100",
    cx: 16.95,
    cy: -116.33,
    r: 3.27,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-101",
    cx: 15.9,
    cy: -113.67,
    r: 3.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-102",
    cx: 14.83,
    cy: -110.5,
    r: 3.95,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-103",
    cx: 39.04,
    cy: -156.26,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-104",
    cx: 37.72,
    cy: -153.16,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-105",
    cx: 27.44,
    cy: -153.58,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: 36,
    cy: -150.71,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-107",
    cx: 34.2,
    cy: -148.77,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-108",
    cx: 27.58,
    cy: -151.15,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-109",
    cx: 32.59,
    cy: -147.3,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-110",
    cx: 27.91,
    cy: -149.02,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: 30.6,
    cy: -146.09,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-112",
    cx: 28.26,
    cy: -146.94,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-113",
    cx: 28.78,
    cy: -144.78,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-114",
    cx: 30.2,
    cy: -142.19,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-115",
    cx: 30.37,
    cy: -139.64,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-116",
    cx: 29.96,
    cy: -136.74,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-117",
    cx: 29.04,
    cy: -133.59,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-118",
    cx: 27.76,
    cy: -130.37,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-119",
    cx: 18.64,
    cy: -131.66,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-120",
    cx: 26.02,
    cy: -127.76,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-121",
    cx: 18.31,
    cy: -128.53,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-122",
    cx: 24.34,
    cy: -125.65,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-123",
    cx: 22.4,
    cy: -124.05,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-124",
    cx: 18.2,
    cy: -126.17,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-125",
    cx: 18.28,
    cy: -123.85,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-126",
    cx: 20.67,
    cy: -122.66,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-127",
    cx: 20.69,
    cy: -119.47,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-128",
    cx: 20.99,
    cy: -117.17,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-129",
    cx: 14.5,
    cy: -119.53,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-130",
    cx: 12.64,
    cy: -117.77,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-131",
    cx: 21.26,
    cy: -114.89,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-132",
    cx: 21.07,
    cy: -112.1,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-133",
    cx: 10.91,
    cy: -115.31,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-134",
    cx: 20.53,
    cy: -108.85,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-135",
    cx: 9.17,
    cy: -112.35,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-136",
    cx: 16.19,
    cy: -121.11,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-137",
    cx: 18.85,
    cy: -121.79,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-138",
    cx: 19.71,
    cy: -134.94,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-139",
    cx: 20.94,
    cy: -138.01,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-140",
    cx: 22.67,
    cy: -140.85,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-141",
    cx: 26.1,
    cy: -144.47,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-142",
    cx: 24.4,
    cy: -142.85,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-143",
    cx: 27.77,
    cy: -156.48,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-144",
    cx: 28.6,
    cy: -159.58,
    r: 0.77,
    xlinkHref: "#radial-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.1,20.35h0a3.51,3.51,0,0,0-1.27-1.27L39.59.48A3.53,3.53,0,0,0,37.83,0h0a3.46,3.46,0,0,0-1.75.48L3.86,19.08a3.6,3.6,0,0,0-1.31,1.29,3.49,3.49,0,0,0-.47,1.76V59.36a3.7,3.7,0,0,0,.47,1.78h.06a3.49,3.49,0,0,0,1.28,1.25L36.11,81a3.71,3.71,0,0,0,1.78.48h0A3.58,3.58,0,0,0,39.61,81L71.84,62.4a3.54,3.54,0,0,0,1.76-3V22.13A3.59,3.59,0,0,0,73.1,20.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.1,20.35h0a3.51,3.51,0,0,0-1.27-1.27L39.59.48A3.53,3.53,0,0,0,37.83,0h0a3.46,3.46,0,0,0-1.75.48L3.86,19.08a3.6,3.6,0,0,0-1.31,1.29,3.49,3.49,0,0,0-.47,1.76V59.36a3.7,3.7,0,0,0,.47,1.78h.06a3.49,3.49,0,0,0,1.28,1.25L36.11,81a3.71,3.71,0,0,0,1.78.48h0A3.58,3.58,0,0,0,39.61,81L71.84,62.4a3.54,3.54,0,0,0,1.76-3V22.13A3.59,3.59,0,0,0,73.1,20.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.82,19.08,39.59.48A3.57,3.57,0,0,0,37.81,0h0L24.23,17.21l11.18-1.66a16.78,16.78,0,0,1,4.8,0l32.88,4.82h0A3.42,3.42,0,0,0,71.82,19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.07.48,3.86,19.08a3.6,3.6,0,0,0-1.31,1.29h0l8.09,20.38,4.14-10.52a16.27,16.27,0,0,1,2.4-4.16L37.83,0h0A3.4,3.4,0,0,0,36.07.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.08,22.13V59.36a3.7,3.7,0,0,0,.47,1.78h0l21.7,3.18-7-8.91a16.72,16.72,0,0,1-2.41-4.15L2.55,20.37h0A3.49,3.49,0,0,0,2.08,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.86,62.39,36.08,81a3.74,3.74,0,0,0,1.78.48h0l13.6-17.22L40.27,65.9a16.16,16.16,0,0,1-4.81,0L2.55,61.1h0A3.45,3.45,0,0,0,3.86,62.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.59,81,71.82,62.39A3.6,3.6,0,0,0,73.1,61.1h0L65,40.75,60.84,51.26a16.83,16.83,0,0,1-2.37,4.16L37.83,81.49h0A3.64,3.64,0,0,0,39.59,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.59,81,71.82,62.39A3.52,3.52,0,0,0,73.1,61.1h0L65,40.75,60.84,51.26a17.15,17.15,0,0,1-2.37,4.16L37.83,81.49h0A3.64,3.64,0,0,0,39.59,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.58,59.36V22.13a3.71,3.71,0,0,0-.48-1.78h0L51.41,17.21l7,8.85a16.86,16.86,0,0,1,2.38,4.16L73.1,61.09h0A3.63,3.63,0,0,0,73.58,59.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.86,78.49A3.66,3.66,0,0,1,36.12,78L6.42,60.86a3.48,3.48,0,0,1-1.21-1.14h0l-.06-.09a3.43,3.43,0,0,1-.47-1.73V23.58a3.37,3.37,0,0,1,.47-1.72A3.41,3.41,0,0,1,6.42,20.6L36.11,3.45A3.39,3.39,0,0,1,37.81,3h0a3.49,3.49,0,0,1,1.72.46L69.28,20.6a3.51,3.51,0,0,1,1.2,1.16h0l.06.08A3.76,3.76,0,0,1,71,23.57V57.9a3.5,3.5,0,0,1-1.72,3L39.55,78a3.44,3.44,0,0,1-1.59.46h-.1ZM5.43,59.38l.07.07a3,3,0,0,0,1.1,1.06L36.31,77.69a3.39,3.39,0,0,0,1.49.41h.06a3,3,0,0,0,1.5-.41l29.7-17.15a3.19,3.19,0,0,0,1.13-1.12,3.07,3.07,0,0,0,.4-1.51V23.58a3.15,3.15,0,0,0-.37-1.48l0-.07a3.16,3.16,0,0,0-1.11-1.1L39.36,3.78a3.27,3.27,0,0,0-1.53-.41h0a3.19,3.19,0,0,0-1.51.41L6.61,20.93a3.25,3.25,0,0,0-1.14,1.13,3,3,0,0,0-.41,1.52V57.9A3.15,3.15,0,0,0,5.43,59.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.84,34a3.58,3.58,0,1,0-4.64-2,3.58,3.58,0,0,0,4.64,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52,37.46a3.59,3.59,0,1,0-2,4.64h0A3.59,3.59,0,0,0,52,37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.64,41.06a3.6,3.6,0,1,0-2.71-6.66h0a3.36,3.36,0,0,0-.43.2A10.79,10.79,0,0,0,42.64,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.39,29.21A21.63,21.63,0,0,0,35.91,16.12h0l-.07,0a25.08,25.08,0,0,0-2.41.78,21.6,21.6,0,1,0,28,12.3ZM57,47.89a3.2,3.2,0,0,0-.18-.74,2.3,2.3,0,0,0-.57-.91,2.24,2.24,0,0,0-.95-.47c-.34-.1-.69-.18-1-.26s-.69-.16-1-.26a1.48,1.48,0,0,1-.83-.53,8.16,8.16,0,0,1-.53-.9,1.88,1.88,0,0,0-.64-.73h0a.16.16,0,0,0,0-.24h0a.16.16,0,0,0-.24,0,.17.17,0,0,0,0,.24.18.18,0,0,0,.23,0,2,2,0,0,1,.54.81,7.71,7.71,0,0,0,.53.93,1.07,1.07,0,0,0,.42.37,2.1,2.1,0,0,0,.53.19,9.46,9.46,0,0,0,1.06.21,6.1,6.1,0,0,1,1,.22,2,2,0,0,1,.88.53A3.52,3.52,0,0,1,57,48a19,19,0,0,1-8.47,6.79l-.81-.44a4.29,4.29,0,0,1,.17-.64,8.63,8.63,0,0,0,.32-1.31,1.31,1.31,0,0,0,0-.68,3.05,3.05,0,0,0-.27-.61c-.23-.38-.47-.74-.73-1.09a8.43,8.43,0,0,1-.69-1.1,2.39,2.39,0,0,1-.33-1.23,4.38,4.38,0,0,1,.89-2.35h0a.16.16,0,0,0,.22-.07.17.17,0,0,0-.07-.24.17.17,0,0,0-.23.08.16.16,0,0,0,.07.22h0a4.18,4.18,0,0,0-.72,1.1A3,3,0,0,0,46,47.71c0,.11,0,.21,0,.32s.06.22.1.33a4.53,4.53,0,0,0,.28.59c.21.39.44.75.67,1.12s.48.73.68,1.11a3.76,3.76,0,0,1,.25.58,1.35,1.35,0,0,1,0,.63,11.47,11.47,0,0,1-.32,1.25c0,.21-.1.42-.13.63A37.56,37.56,0,0,1,40,48.45l.37-.19a6.92,6.92,0,0,0,.84-.47,1,1,0,0,0,.35-.39,2.29,2.29,0,0,0,.17-.46,7.58,7.58,0,0,0,.18-.95,7.51,7.51,0,0,1,.21-.94,1.77,1.77,0,0,1,.47-.8,3.53,3.53,0,0,1,1.7-.77h0a3,3,0,0,0-1,.18,2.11,2.11,0,0,0-.84.53,2,2,0,0,0-.43.79c-.09.31-.16.62-.24.94s-.15.62-.24.92a1.37,1.37,0,0,1-.47.79c-.25.18-.53.32-.81.49a2.92,2.92,0,0,0-.37.24c-.71-.71-1.41-1.48-2.11-2.31A25.45,25.45,0,0,1,33,37.2l.26.09a7.59,7.59,0,0,0,.93.27,1.06,1.06,0,0,0,.53,0,1.82,1.82,0,0,0,.45-.2c.29-.16.53-.36.81-.53a6.16,6.16,0,0,1,.8-.53,1.85,1.85,0,0,1,.9-.23,3.25,3.25,0,0,1,1.59.57.14.14,0,0,0,0,.09h0a.17.17,0,0,0,.22.1h0a.16.16,0,0,0,.11-.2h0a.18.18,0,0,0-.22-.11.22.22,0,0,0-.1.09,3.18,3.18,0,0,0-.67-.43,2.3,2.3,0,0,0-1-.23,2.07,2.07,0,0,0-.92.32l-.83.49c-.3.17-.53.34-.82.49a1.27,1.27,0,0,1-.87.2,8.24,8.24,0,0,1-.92-.23L33,37.1a23.55,23.55,0,0,1-.79-8.92,3.11,3.11,0,0,1,.41.4,8.85,8.85,0,0,0,.74.76,1,1,0,0,0,.5.24,2.32,2.32,0,0,0,.53.05,9.28,9.28,0,0,0,1-.08,6.27,6.27,0,0,1,1.06-.05,2,2,0,0,1,1,.26,3.81,3.81,0,0,1,1.3,1.59h0a3.37,3.37,0,0,0-.47-1,2.37,2.37,0,0,0-.74-.77,2.26,2.26,0,0,0-1.06-.2c-.35,0-.7,0-1.06,0s-.69,0-1,0a1.42,1.42,0,0,1-.94-.27,10.07,10.07,0,0,1-.75-.72,2.63,2.63,0,0,0-.49-.39A30,30,0,0,1,33.83,21c.1.16.19.33.28.5a8.43,8.43,0,0,0,.59,1.06,1.27,1.27,0,0,0,.47.42,3.14,3.14,0,0,0,.58.22c.39.11.8.17,1.19.24a7.75,7.75,0,0,1,1.18.26,2.23,2.23,0,0,1,1.06.64,4.1,4.1,0,0,1,1,2.12h0a3.56,3.56,0,0,0-.24-1.2,2.74,2.74,0,0,0-.64-1.06L39,24a1.17,1.17,0,0,0-.27-.15l-.57-.21c-.4-.11-.79-.2-1.18-.29s-.79-.18-1.17-.29a2.5,2.5,0,0,1-.53-.23,1.09,1.09,0,0,1-.43-.37c-.22-.34-.42-.7-.61-1.06a4.41,4.41,0,0,0-.35-.53c.22-.6.46-1.22.71-1.83a19.06,19.06,0,0,1,10.55-.72,3.39,3.39,0,0,0-.46.72,2.3,2.3,0,0,0-.25,1.06,2.25,2.25,0,0,0,.34,1.06c.18.31.37.62.56.93s.38.61.53.92a3,3,0,0,1,.2.49,1,1,0,0,1,0,.49c-.06.35-.17.69-.26,1.06a2.09,2.09,0,0,0-.09,1,.16.16,0,0,0-.12.13.18.18,0,0,0,.14.2.16.16,0,0,0,.22-.09s0,0,0-.07h0a.17.17,0,0,0-.13-.2h0a2.21,2.21,0,0,1,.18-.91A8,8,0,0,0,46.3,24a1.1,1.1,0,0,0,0-.57,3.54,3.54,0,0,0-.23-.53c-.19-.31-.39-.61-.61-.9a7.23,7.23,0,0,1-.6-.85,2,2,0,0,1-.27-1,3.62,3.62,0,0,1,.64-1.8,19.27,19.27,0,0,1,10.39,6,2.71,2.71,0,0,0-.75.16,1.77,1.77,0,0,0-.76.47,1.87,1.87,0,0,0-.4.81c-.08.28-.15.57-.22.85a8.15,8.15,0,0,1-.22.85,1.2,1.2,0,0,1-.43.69,7.66,7.66,0,0,1-.74.45,1.64,1.64,0,0,0-.61.53.19.19,0,0,0-.19,0h0a.18.18,0,0,0,0,.24h0a.18.18,0,0,0,.25,0h0a.18.18,0,0,0,0-.24l0,0a1.88,1.88,0,0,1,.64-.44,7.37,7.37,0,0,0,.78-.43,1.26,1.26,0,0,0,.51-.76,8.52,8.52,0,0,0,.16-.88,5,5,0,0,1,.19-.85,1.49,1.49,0,0,1,.44-.73,3,3,0,0,1,1.44-.69,19.11,19.11,0,0,1,4.65,10.88,2.78,2.78,0,0,0-.59-.37A1.65,1.65,0,0,0,58,35c-.26.15-.53.3-.77.46l-.76.45a1.32,1.32,0,0,1-.8.19c-.29-.05-.57-.14-.86-.21a1.76,1.76,0,0,0-.72-.08.16.16,0,0,0-.24,0,.16.16,0,0,0-.06.13h0a.17.17,0,0,0,.16.17h0a.18.18,0,0,0,.17-.17h0v-.06a2.44,2.44,0,0,1,.66.15,5.27,5.27,0,0,0,.86.25,1.27,1.27,0,0,0,.9-.22,7.57,7.57,0,0,0,.74-.52A4.52,4.52,0,0,1,58,35a1.74,1.74,0,0,1,.84-.21,3.11,3.11,0,0,1,1.47.53A19.21,19.21,0,0,1,57,47.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.11,45.13h0a.18.18,0,0,0-.22-.09h0a.17.17,0,0,0-.06.24.17.17,0,0,0,.19.08A.17.17,0,0,0,48.11,45.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.69,44.84a.18.18,0,0,0-.24-.07h0a.17.17,0,0,0-.07.23.17.17,0,0,0,.22.08h0A.19.19,0,0,0,48.69,44.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49,44.45h0a.18.18,0,0,0,0,.24.16.16,0,0,0,.23.06h0a.18.18,0,0,0,0-.25A.18.18,0,0,0,49,44.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.55,44.1h0a.17.17,0,0,0,0,.23h0a.19.19,0,0,0,.25.05.17.17,0,0,0,0-.23h0A.2.2,0,0,0,49.55,44.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.07,43.72A.16.16,0,0,0,50,44h0a.17.17,0,0,0,.24,0h0a.18.18,0,0,0,0-.24A.17.17,0,0,0,50.07,43.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.55,43.3h0a.2.2,0,0,0,0,.25h0a.17.17,0,0,0,.23,0h0a.18.18,0,0,0,0-.25.17.17,0,0,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.68,42.36h0a.16.16,0,0,0-.23,0h0a.17.17,0,0,0,.26.22h0a.17.17,0,0,0,0-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.82,41.87h0a.19.19,0,0,0,0,.25h0a.17.17,0,0,0,.23,0h0a.18.18,0,0,0-.28-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.44,41.28h0a.18.18,0,0,0-.24,0h0a.16.16,0,0,0,0,.23h0a.18.18,0,0,0,.24-.05.16.16,0,0,0-.05-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.76,40.75a.17.17,0,0,0-.23.06h0a.16.16,0,0,0,.07.23h0a.17.17,0,0,0,.23-.06h0a.17.17,0,0,0-.06-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.05,40.14a.18.18,0,0,0-.23.09h0a.18.18,0,0,0,.08.23h0a.18.18,0,0,0,.23-.08h0a.17.17,0,0,0-.07-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.3,39.55a.17.17,0,0,0-.22.09h0a.18.18,0,0,0,.09.22h0a.17.17,0,0,0,.23-.09.16.16,0,0,0-.1-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.51,38.93a.18.18,0,0,0-.22.11h0a.17.17,0,0,0,.11.21h0a.18.18,0,0,0,.22-.11A.17.17,0,0,0,53.51,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.68,38.3a.18.18,0,0,0-.22.12h0a.2.2,0,0,0,.13.21h0a.17.17,0,0,0,.21-.13h0a.16.16,0,0,0-.12-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.8,37.66h0a.16.16,0,0,0-.19.13h0a.17.17,0,0,0,.13.2.18.18,0,0,0,.21-.13.18.18,0,0,0-.14-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.89,37h0a.18.18,0,0,0-.19.14h0a.18.18,0,0,0,.15.19h0a.18.18,0,0,0,.19-.14h0A.18.18,0,0,0,53.89,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.94,36.36a.16.16,0,0,0-.18.16h0a.17.17,0,0,0,.15.18h0a.17.17,0,0,0,.19-.15h0a.18.18,0,0,0-.16-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.89,35.06a.17.17,0,0,0-.16.18h0a.17.17,0,0,0,.18.15h0a.16.16,0,0,0,.16-.18h0a.17.17,0,0,0-.17-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.81,34.4h0a.16.16,0,0,0-.14.19h0a.17.17,0,0,0,.19.15h0a.18.18,0,0,0,.14-.19h0a.16.16,0,0,0-.19-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.55,34h0a.19.19,0,0,0,.2.14h0a.18.18,0,0,0-.07-.35h0A.18.18,0,0,0,53.55,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.41,33.34a.16.16,0,0,0,.2.12h0a.18.18,0,0,0,.13-.21h0a.16.16,0,0,0-.2-.12h0A.16.16,0,0,0,53.41,33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.21,32.74a.16.16,0,0,0,.21.1h0a.17.17,0,0,0,.11-.21h0a.18.18,0,0,0-.22-.1h0A.17.17,0,0,0,53.21,32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53,32.14h0a.16.16,0,0,0,.22.09h0a.17.17,0,0,0,.1-.23h0a.19.19,0,0,0-.23-.09A.2.2,0,0,0,53,32.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.7,31.56a.17.17,0,0,0,.23.07h0a.17.17,0,0,0,.08-.22h0a.17.17,0,0,0-.24,0,.17.17,0,0,0-.07.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.4,31h0a.18.18,0,0,0,.23.06h0a.16.16,0,0,0,.07-.22v0a.18.18,0,0,0-.24-.06.17.17,0,0,0-.05.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.29,30.5h0a.16.16,0,0,0,.05-.23h0a.18.18,0,1,0-.05.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.68,29.94h0a.16.16,0,0,0,.23,0,.16.16,0,0,0,0-.24.17.17,0,0,0-.27.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.82,29h0a.16.16,0,0,0,.24,0h0a.16.16,0,0,0,0-.23h0a.18.18,0,0,0-.24,0h0a.2.2,0,0,0,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.35,28.58h0a.18.18,0,0,0,.24,0h0a.18.18,0,0,0,0-.25h0a.17.17,0,0,0-.24,0h0a.18.18,0,0,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.85,28.15h0a.17.17,0,0,0,.24,0h0a.17.17,0,0,0-.25-.23l0,0h0a.17.17,0,0,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.33,27.78h0a.16.16,0,0,0,.23-.05h0a.17.17,0,0,0-.05-.24.17.17,0,0,0-.23.05A.18.18,0,0,0,49.33,27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.78,27.44h0a.16.16,0,0,0,.23-.06h0a.18.18,0,0,0-.06-.24.15.15,0,0,0-.22.06h0A.17.17,0,0,0,48.78,27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.21,27.14h0a.18.18,0,0,0,.23-.08h0a.16.16,0,0,0-.07-.22h0a.18.18,0,0,0-.23.08.17.17,0,0,0,.07.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.63,26.88h0a.16.16,0,0,0,.22-.09h0a.17.17,0,0,0-.09-.23h0a.19.19,0,0,0-.23.1A.17.17,0,0,0,47.63,26.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47,26.66a.18.18,0,0,0,.22-.11.17.17,0,0,0-.1-.22h0a.18.18,0,0,0-.22.11h0A.18.18,0,0,0,47,26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.41,26.46a.18.18,0,0,0,.21-.12h0a.16.16,0,0,0-.11-.21h0a.17.17,0,0,0-.1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.16,26.23a.18.18,0,0,0,.19-.15h0a.17.17,0,0,0-.15-.19h0A.17.17,0,0,0,45,26h0A.17.17,0,0,0,45.16,26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.52,26.17A.18.18,0,0,0,44.7,26h0a.16.16,0,0,0-.14-.17h0a.18.18,0,0,0,0,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.88,26.15h0a.18.18,0,0,0,.17-.17h0a.18.18,0,0,0-.16-.18h0a.18.18,0,0,0-.17.17h0A.18.18,0,0,0,43.88,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.24,26.17a.17.17,0,0,0,.15-.18h0a.17.17,0,0,0-.18-.17h0a.17.17,0,0,0-.15.19h0A.18.18,0,0,0,43.24,26.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.6,26.24a.18.18,0,0,0,.14-.2h0a.15.15,0,0,0-.17-.15h0a.18.18,0,0,0-.13.21.18.18,0,0,0,.18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42,26.34h0A.17.17,0,0,0,41.9,26h0a.18.18,0,0,0-.14.19h0A.17.17,0,0,0,42,26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.34,26.49h0a.17.17,0,0,0,.12-.21h0a.18.18,0,0,0-.21-.13.16.16,0,0,0-.12.2h0a.19.19,0,0,0,.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.71,26.68h0a.17.17,0,0,0,.1-.21h0a.16.16,0,0,0-.2-.11h0a.18.18,0,0,0-.11.23A.2.2,0,0,0,40.71,26.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40,27.23h0a.19.19,0,0,0,.23-.1h0a.17.17,0,0,0-.1-.22.16.16,0,0,0-.22.09h0A.18.18,0,0,0,40,27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.79,27.83h0a.17.17,0,0,0,.22-.1h0a.16.16,0,0,0-.09-.22h0a.19.19,0,0,0-.23.1h0a.18.18,0,0,0,.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.58,28.45a.17.17,0,0,0,.22-.11h0a.16.16,0,0,0-.11-.21h0a.16.16,0,0,0-.21.1h0A.17.17,0,0,0,39.58,28.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.6,29h0a.18.18,0,0,0-.11-.22.19.19,0,0,0-.22.12.17.17,0,0,0,.12.21h0A.16.16,0,0,0,39.6,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.24,29.71h0a.16.16,0,0,0,.2-.12h0a.18.18,0,0,0-.13-.22h0a.17.17,0,0,0-.2.13h0a.18.18,0,0,0,.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.12,30.35h0a.16.16,0,0,0,.19-.13h0a.18.18,0,0,0-.13-.21.17.17,0,1,0-.06.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,31h0a.19.19,0,0,0,.2-.14h0a.17.17,0,0,0-.15-.19h0a.18.18,0,0,0-.2.14h0A.17.17,0,0,0,39,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.92,31.64h0a.17.17,0,0,0,.2-.13v0h0A.17.17,0,0,0,39,31.3h0a.17.17,0,0,0-.19.14h0A.19.19,0,0,0,38.92,31.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.86,32.28h0a.16.16,0,0,0,.18-.16h0a.17.17,0,0,0-.15-.18h0a.19.19,0,0,0-.19.17A.17.17,0,0,0,38.86,32.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.85,32.94a.17.17,0,0,0,.18-.16h0a.18.18,0,0,0-.17-.17h0a.18.18,0,0,0-.18.17h0a.17.17,0,0,0,.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.88,33.6h0a.18.18,0,0,0,.16-.18h0a.17.17,0,0,0-.18-.17h0a.18.18,0,0,0-.16.18h0a.17.17,0,0,0,.18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.08,34.06a.17.17,0,0,0-.34,0h0a.18.18,0,0,0,.19.15A.16.16,0,0,0,39.08,34.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,34.89h0a.17.17,0,0,0,.15-.19h0a.18.18,0,0,0-.19-.15h0a.16.16,0,0,0-.15.18h0a.17.17,0,0,0,.18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.16,35.53a.17.17,0,1,0-.21-.14h0a.19.19,0,0,0,.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.44,36h0a.17.17,0,0,0-.21-.12h0a.15.15,0,0,0-.12.19h0a.16.16,0,0,0,.21.12h0a.15.15,0,0,0,.11-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.85,37.17h0a.18.18,0,0,0-.22-.1.19.19,0,0,0-.1.23h0a.16.16,0,0,0,.21.1h0A.19.19,0,0,0,39.85,37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.1,37.76h0a.15.15,0,0,0-.21-.08h0a.17.17,0,0,0-.09.23A.18.18,0,0,0,40,38h0a.18.18,0,0,0,.09-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.39,38.34h0a.18.18,0,0,0-.23-.07.17.17,0,1,0,.15.3h0A.17.17,0,0,0,40.39,38.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.71,38.9h0a.19.19,0,0,0-.24,0h0a.16.16,0,0,0-.06.23h0a.18.18,0,0,0,.24.06h0a.15.15,0,0,0,.06-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.8,39.4a.19.19,0,0,0-.06.24h0a.18.18,0,0,0,.24,0h0a.19.19,0,0,0,0-.25.17.17,0,0,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.4,40h0a.16.16,0,0,0-.23,0h0a.16.16,0,0,0-.05.23h0a.17.17,0,0,0,.23.05h0a.17.17,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.79,40.5h0a.18.18,0,0,0-.24,0,.19.19,0,0,0,0,.25h0a.17.17,0,0,0,.24,0h0a.16.16,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.2,41h0a.17.17,0,1,0,0,.23h0a.18.18,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.39,41.47a.18.18,0,0,0,0,.24h0a.17.17,0,0,0,.24,0h0a.17.17,0,1,0-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.09,41.94a.2.2,0,0,0-.25,0,.19.19,0,0,0,0,.25.18.18,0,0,0,.2,0h0A.2.2,0,0,0,43.09,41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.31,42.4h0a.16.16,0,0,0,0,.24h0a.16.16,0,0,0,.24,0h0a.16.16,0,0,0,0-.24.17.17,0,0,0-.24,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44,42.82a.16.16,0,0,0-.24,0,.17.17,0,0,0,0,.24h0a.16.16,0,0,0,.24,0h0A.16.16,0,0,0,44,42.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.29,43.26a.18.18,0,0,0,0,.24.16.16,0,0,0,.24,0h0a.17.17,0,0,0,0-.24A.17.17,0,0,0,44.29,43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.81,43.66h0a.17.17,0,0,0,0,.24h0a.16.16,0,0,0,.23,0h0a.15.15,0,0,0,0-.23h0a.17.17,0,0,0-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.34,44a.18.18,0,0,0,0,.25h0a.16.16,0,0,0,.23,0h0a.19.19,0,0,0,0-.24h0A.17.17,0,0,0,45.34,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.11,44.36a.16.16,0,0,0-.23,0,.19.19,0,0,0,0,.24h0a.19.19,0,0,0,.23-.06h0A.17.17,0,0,0,46.11,44.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.66,44.7a.17.17,0,0,0-.23.06h0a.16.16,0,0,0,.06.23h0a.17.17,0,0,0,.23,0h0A.17.17,0,0,0,46.66,44.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "47.46 45.52 47.46 45.53 47.47 45.53 47.47 45.53 47.46 45.52 47.46 45.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.84,34a3.58,3.58,0,1,0-4.64-2,3.58,3.58,0,0,0,4.64,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M52,37.46a3.59,3.59,0,1,0-2,4.64h0A3.59,3.59,0,0,0,52,37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.64,41.06a3.6,3.6,0,1,0-2.71-6.66h0a3.36,3.36,0,0,0-.43.2A10.79,10.79,0,0,0,42.64,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.11,45.13h0a.18.18,0,0,0-.22-.09h0a.17.17,0,0,0-.06.24.17.17,0,0,0,.19.08A.17.17,0,0,0,48.11,45.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.69,44.84a.18.18,0,0,0-.24-.07h0a.17.17,0,0,0-.07.23.17.17,0,0,0,.22.08h0A.19.19,0,0,0,48.69,44.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49,44.45h0a.18.18,0,0,0,0,.24.16.16,0,0,0,.23.06h0a.18.18,0,0,0,0-.25A.18.18,0,0,0,49,44.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.55,44.1h0a.17.17,0,0,0,0,.23h0a.19.19,0,0,0,.25.05.17.17,0,0,0,0-.23h0A.2.2,0,0,0,49.55,44.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.07,43.72A.16.16,0,0,0,50,44h0a.17.17,0,0,0,.24,0h0a.18.18,0,0,0,0-.24A.17.17,0,0,0,50.07,43.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.55,43.3h0a.2.2,0,0,0,0,.25h0a.17.17,0,0,0,.23,0h0a.18.18,0,0,0,0-.25.17.17,0,0,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.68,42.36h0a.16.16,0,0,0-.23,0h0a.17.17,0,0,0,.26.22h0a.17.17,0,0,0,0-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.82,41.87h0a.19.19,0,0,0,0,.25h0a.17.17,0,0,0,.23,0h0a.18.18,0,0,0-.28-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.44,41.28h0a.18.18,0,0,0-.24,0h0a.16.16,0,0,0,0,.23h0a.18.18,0,0,0,.24-.05.16.16,0,0,0-.05-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.76,40.75a.17.17,0,0,0-.23.06h0a.16.16,0,0,0,.07.23h0a.17.17,0,0,0,.23-.06h0a.17.17,0,0,0-.06-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.05,40.14a.18.18,0,0,0-.23.09h0a.18.18,0,0,0,.08.23h0a.18.18,0,0,0,.23-.08h0a.17.17,0,0,0-.07-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.3,39.55a.17.17,0,0,0-.22.09h0a.18.18,0,0,0,.09.22h0a.17.17,0,0,0,.23-.09.16.16,0,0,0-.1-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.51,38.93a.18.18,0,0,0-.22.11h0a.17.17,0,0,0,.11.21h0a.18.18,0,0,0,.22-.11A.17.17,0,0,0,53.51,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.68,38.3a.18.18,0,0,0-.22.12h0a.2.2,0,0,0,.13.21h0a.17.17,0,0,0,.21-.13h0a.16.16,0,0,0-.12-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.8,37.66h0a.16.16,0,0,0-.19.13h0a.17.17,0,0,0,.13.2.18.18,0,0,0,.21-.13.18.18,0,0,0-.14-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.89,37h0a.18.18,0,0,0-.19.14h0a.18.18,0,0,0,.15.19h0a.18.18,0,0,0,.19-.14h0A.18.18,0,0,0,53.89,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.94,36.36a.16.16,0,0,0-.18.16h0a.17.17,0,0,0,.15.18h0a.17.17,0,0,0,.19-.15h0a.18.18,0,0,0-.16-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.89,35.06a.17.17,0,0,0-.16.18h0a.17.17,0,0,0,.18.15h0a.16.16,0,0,0,.16-.18h0a.17.17,0,0,0-.17-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.81,34.4h0a.16.16,0,0,0-.14.19h0a.17.17,0,0,0,.19.15h0a.18.18,0,0,0,.14-.19h0a.16.16,0,0,0-.19-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.55,34h0a.19.19,0,0,0,.2.14h0a.18.18,0,0,0-.07-.35h0A.18.18,0,0,0,53.55,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.41,33.34a.16.16,0,0,0,.2.12h0a.18.18,0,0,0,.13-.21h0a.16.16,0,0,0-.2-.12h0A.16.16,0,0,0,53.41,33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.21,32.74a.16.16,0,0,0,.21.1h0a.17.17,0,0,0,.11-.21h0a.18.18,0,0,0-.22-.1h0A.17.17,0,0,0,53.21,32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53,32.14h0a.16.16,0,0,0,.22.09h0a.17.17,0,0,0,.1-.23h0a.19.19,0,0,0-.23-.09A.2.2,0,0,0,53,32.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.7,31.56a.17.17,0,0,0,.23.07h0a.17.17,0,0,0,.08-.22h0a.17.17,0,0,0-.24,0,.17.17,0,0,0-.07.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.4,31h0a.18.18,0,0,0,.23.06h0a.16.16,0,0,0,.07-.22v0a.18.18,0,0,0-.24-.06.17.17,0,0,0-.05.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.29,30.5h0a.16.16,0,0,0,.05-.23h0a.18.18,0,1,0-.05.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.68,29.94h0a.16.16,0,0,0,.23,0,.16.16,0,0,0,0-.24.17.17,0,0,0-.27.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.82,29h0a.16.16,0,0,0,.24,0h0a.16.16,0,0,0,0-.23h0a.18.18,0,0,0-.24,0h0a.2.2,0,0,0,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.35,28.58h0a.18.18,0,0,0,.24,0h0a.18.18,0,0,0,0-.25h0a.17.17,0,0,0-.24,0h0a.18.18,0,0,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.85,28.15h0a.17.17,0,0,0,.24,0h0a.17.17,0,0,0-.25-.23l0,0h0a.17.17,0,0,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.33,27.78h0a.16.16,0,0,0,.23-.05h0a.17.17,0,0,0-.05-.24.17.17,0,0,0-.23.05A.18.18,0,0,0,49.33,27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.78,27.44h0a.16.16,0,0,0,.23-.06h0a.18.18,0,0,0-.06-.24.15.15,0,0,0-.22.06h0A.17.17,0,0,0,48.78,27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.21,27.14h0a.18.18,0,0,0,.23-.08h0a.16.16,0,0,0-.07-.22h0a.18.18,0,0,0-.23.08.17.17,0,0,0,.07.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.63,26.88h0a.16.16,0,0,0,.22-.09h0a.17.17,0,0,0-.09-.23h0a.19.19,0,0,0-.23.1A.17.17,0,0,0,47.63,26.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47,26.66a.18.18,0,0,0,.22-.11.17.17,0,0,0-.1-.22h0a.18.18,0,0,0-.22.11h0A.18.18,0,0,0,47,26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.41,26.46a.18.18,0,0,0,.21-.12h0a.16.16,0,0,0-.11-.21h0a.17.17,0,0,0-.1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.16,26.23a.18.18,0,0,0,.19-.15h0a.17.17,0,0,0-.15-.19h0A.17.17,0,0,0,45,26h0A.17.17,0,0,0,45.16,26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.52,26.17A.18.18,0,0,0,44.7,26h0a.16.16,0,0,0-.14-.17h0a.18.18,0,0,0,0,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.88,26.15h0a.18.18,0,0,0,.17-.17h0a.18.18,0,0,0-.16-.18h0a.18.18,0,0,0-.17.17h0A.18.18,0,0,0,43.88,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.24,26.17a.17.17,0,0,0,.15-.18h0a.17.17,0,0,0-.18-.17h0a.17.17,0,0,0-.15.19h0A.18.18,0,0,0,43.24,26.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.6,26.24a.18.18,0,0,0,.14-.2h0a.15.15,0,0,0-.17-.15h0a.18.18,0,0,0-.13.21.18.18,0,0,0,.18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42,26.34h0A.17.17,0,0,0,41.9,26h0a.18.18,0,0,0-.14.19h0A.17.17,0,0,0,42,26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.34,26.49h0a.17.17,0,0,0,.12-.21h0a.18.18,0,0,0-.21-.13.16.16,0,0,0-.12.2h0a.19.19,0,0,0,.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.71,26.68h0a.17.17,0,0,0,.1-.21h0a.16.16,0,0,0-.2-.11h0a.18.18,0,0,0-.11.23A.2.2,0,0,0,40.71,26.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40,27.23h0a.19.19,0,0,0,.23-.1h0a.17.17,0,0,0-.1-.22.16.16,0,0,0-.22.09h0A.18.18,0,0,0,40,27.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.79,27.83h0a.17.17,0,0,0,.22-.1h0a.16.16,0,0,0-.09-.22h0a.19.19,0,0,0-.23.1h0a.18.18,0,0,0,.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.58,28.45a.17.17,0,0,0,.22-.11h0a.16.16,0,0,0-.11-.21h0a.16.16,0,0,0-.21.1h0A.17.17,0,0,0,39.58,28.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.6,29h0a.18.18,0,0,0-.11-.22.19.19,0,0,0-.22.12.17.17,0,0,0,.12.21h0A.16.16,0,0,0,39.6,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.24,29.71h0a.16.16,0,0,0,.2-.12h0a.18.18,0,0,0-.13-.22h0a.17.17,0,0,0-.2.13h0a.18.18,0,0,0,.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.12,30.35h0a.16.16,0,0,0,.19-.13h0a.18.18,0,0,0-.13-.21.17.17,0,1,0-.06.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,31h0a.19.19,0,0,0,.2-.14h0a.17.17,0,0,0-.15-.19h0a.18.18,0,0,0-.2.14h0A.17.17,0,0,0,39,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.92,31.64h0a.17.17,0,0,0,.2-.13v0h0A.17.17,0,0,0,39,31.3h0a.17.17,0,0,0-.19.14h0A.19.19,0,0,0,38.92,31.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.86,32.28h0a.16.16,0,0,0,.18-.16h0a.17.17,0,0,0-.15-.18h0a.19.19,0,0,0-.19.17A.17.17,0,0,0,38.86,32.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.85,32.94a.17.17,0,0,0,.18-.16h0a.18.18,0,0,0-.17-.17h0a.18.18,0,0,0-.18.17h0a.17.17,0,0,0,.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.88,33.6h0a.18.18,0,0,0,.16-.18h0a.17.17,0,0,0-.18-.17h0a.18.18,0,0,0-.16.18h0a.17.17,0,0,0,.18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.08,34.06a.17.17,0,0,0-.34,0h0a.18.18,0,0,0,.19.15A.16.16,0,0,0,39.08,34.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,34.89h0a.17.17,0,0,0,.15-.19h0a.18.18,0,0,0-.19-.15h0a.16.16,0,0,0-.15.18h0a.17.17,0,0,0,.18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.16,35.53a.17.17,0,1,0-.21-.14h0a.19.19,0,0,0,.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.44,36h0a.17.17,0,0,0-.21-.12h0a.15.15,0,0,0-.12.19h0a.16.16,0,0,0,.21.12h0a.15.15,0,0,0,.11-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39.85,37.17h0a.18.18,0,0,0-.22-.1.19.19,0,0,0-.1.23h0a.16.16,0,0,0,.21.1h0A.19.19,0,0,0,39.85,37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.1,37.76h0a.15.15,0,0,0-.21-.08h0a.17.17,0,0,0-.09.23A.18.18,0,0,0,40,38h0a.18.18,0,0,0,.09-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.39,38.34h0a.18.18,0,0,0-.23-.07.17.17,0,1,0,.15.3h0A.17.17,0,0,0,40.39,38.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.71,38.9h0a.19.19,0,0,0-.24,0h0a.16.16,0,0,0-.06.23h0a.18.18,0,0,0,.24.06h0a.15.15,0,0,0,.06-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.8,39.4a.19.19,0,0,0-.06.24h0a.18.18,0,0,0,.24,0h0a.19.19,0,0,0,0-.25.17.17,0,0,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.4,40h0a.16.16,0,0,0-.23,0h0a.16.16,0,0,0-.05.23h0a.17.17,0,0,0,.23.05h0a.17.17,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.79,40.5h0a.18.18,0,0,0-.24,0,.19.19,0,0,0,0,.25h0a.17.17,0,0,0,.24,0h0a.16.16,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.2,41h0a.17.17,0,1,0,0,.23h0a.18.18,0,0,0,0-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.39,41.47a.18.18,0,0,0,0,.24h0a.17.17,0,0,0,.24,0h0a.17.17,0,1,0-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.09,41.94a.2.2,0,0,0-.25,0,.19.19,0,0,0,0,.25.18.18,0,0,0,.2,0h0A.2.2,0,0,0,43.09,41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.31,42.4h0a.16.16,0,0,0,0,.24h0a.16.16,0,0,0,.24,0h0a.16.16,0,0,0,0-.24.17.17,0,0,0-.24,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44,42.82a.16.16,0,0,0-.24,0,.17.17,0,0,0,0,.24h0a.16.16,0,0,0,.24,0h0A.16.16,0,0,0,44,42.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.29,43.26a.18.18,0,0,0,0,.24.16.16,0,0,0,.24,0h0a.17.17,0,0,0,0-.24A.17.17,0,0,0,44.29,43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.81,43.66h0a.17.17,0,0,0,0,.24h0a.16.16,0,0,0,.23,0h0a.15.15,0,0,0,0-.23h0a.17.17,0,0,0-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.34,44a.18.18,0,0,0,0,.25h0a.16.16,0,0,0,.23,0h0a.19.19,0,0,0,0-.24h0A.17.17,0,0,0,45.34,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.11,44.36a.16.16,0,0,0-.23,0,.19.19,0,0,0,0,.24h0a.19.19,0,0,0,.23-.06h0A.17.17,0,0,0,46.11,44.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.66,44.7a.17.17,0,0,0-.23.06h0a.16.16,0,0,0,.06.23h0a.17.17,0,0,0,.23,0h0A.17.17,0,0,0,46.66,44.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "47.46 45.52 47.46 45.53 47.47 45.53 47.47 45.53 47.46 45.52 47.46 45.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M49.63,55.74h0a.36.36,0,0,0-.46-.18h0a.36.36,0,0,0,.29.65h0a.36.36,0,0,0,.18-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.82,55.15a.35.35,0,0,0-.47-.15h0a.35.35,0,0,0,.31.63h0A.35.35,0,0,0,50.82,55.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M51.49,54.36h0a.34.34,0,0,0-.12.48.35.35,0,0,0,.48.12h0a.35.35,0,0,0-.36-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.59,53.64h0a.34.34,0,0,0-.09.48h0a.35.35,0,0,0,.48.11h0a.35.35,0,0,0,.09-.49h0A.36.36,0,0,0,52.59,53.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M53.63,52.86a.36.36,0,0,0-.06.49h0a.35.35,0,0,0,.49.07h0a.35.35,0,0,0,0-.49h0A.36.36,0,0,0,53.63,52.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M54.62,52h0a.37.37,0,0,0,0,.5h0a.35.35,0,0,0,.5,0h0a.34.34,0,0,0,0-.49h0A.37.37,0,0,0,54.62,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M56.93,50.09h0a.35.35,0,0,0-.49.09.33.33,0,0,0,.53.4h0a.35.35,0,0,0,0-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M57.24,49.1h0a.36.36,0,0,0,.08.49h0a.34.34,0,0,0,.48-.06h0a.34.34,0,0,0-.14-.48A.35.35,0,0,0,57.24,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M58.47,47.92h0A.37.37,0,0,0,58,48h0a.35.35,0,0,0,.11.48h0a.34.34,0,0,0,.48-.09h0a.34.34,0,0,0-.1-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59.13,46.76a.35.35,0,0,0-.34.62h0a.36.36,0,0,0,.48-.13h0A.36.36,0,0,0,59.13,46.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M59.71,45.57a.35.35,0,0,0-.46.17h0a.34.34,0,0,0,.17.46h0a.33.33,0,0,0,.45-.14v0h0a.34.34,0,0,0-.15-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.22,44.34a.36.36,0,0,0-.45.2h0A.36.36,0,0,0,60,45h0a.36.36,0,0,0,.46-.2.33.33,0,0,0-.18-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M60.65,43.08a.37.37,0,0,0-.44.23h0a.36.36,0,0,0,.22.44h0a.35.35,0,0,0,.45-.21v0A.35.35,0,0,0,60.65,43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M61,41.8a.36.36,0,0,0-.42.25h0a.36.36,0,0,0,.26.43h0a.36.36,0,0,0,.42-.26h0a.33.33,0,0,0-.25-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.25,40.49h0a.36.36,0,0,0-.4.28h0a.36.36,0,0,0,.7.13.37.37,0,0,0-.29-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M61.43,39.16h0a.34.34,0,0,0-.38.3h0a.36.36,0,0,0,.3.39h0a.35.35,0,0,0,.39-.3h0A.36.36,0,0,0,61.43,39.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M61.52,37.85a.36.36,0,0,0-.37.33h0a.38.38,0,0,0,.34.37h0a.35.35,0,0,0,.37-.32h0a.35.35,0,0,0-.32-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M61.44,35.19a.35.35,0,0,0-.32.37h0a.36.36,0,0,0,.38.32h0a.35.35,0,0,0,.35-.35.35.35,0,0,0-.35-.35h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M61.27,33.87h0a.35.35,0,0,0-.3.39h0a.35.35,0,0,0,.4.29h0a.35.35,0,0,0,.3-.38v0h0a.34.34,0,0,0-.39-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M60.74,33h0a.35.35,0,0,0,.41.26h0a.35.35,0,0,0,.28-.41.34.34,0,0,0-.41-.27h0A.37.37,0,0,0,60.74,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M60.43,31.71a.35.35,0,0,0,.43.24h0a.35.35,0,0,0,.25-.42h0a.35.35,0,0,0-.44-.24A.34.34,0,0,0,60.43,31.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M60,30.46a.36.36,0,0,0,.45.22h0a.35.35,0,0,0,.22-.44h0a.36.36,0,0,0-.67.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M59.56,29.25h0a.36.36,0,0,0,.46.18h0a.35.35,0,0,0,.19-.45h0a.35.35,0,0,0-.45-.19h0A.36.36,0,0,0,59.56,29.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M59,28.05a.36.36,0,0,0,.47.16h0a.37.37,0,0,0,.16-.48h0a.35.35,0,0,0-.49-.1.35.35,0,0,0-.14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M58.38,26.91h0a.36.36,0,0,0,.48.13h0a.36.36,0,0,0,.13-.47v0a.35.35,0,0,0-.6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M58.17,25.9h0a.35.35,0,0,0,.09-.49h0a.35.35,0,0,0-.49-.09.35.35,0,0,0,.4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M56.91,24.75h0a.35.35,0,0,0,.53-.43.33.33,0,0,0-.47-.08l0,0a.35.35,0,0,0-.07.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M55.17,22.8h0a.35.35,0,0,0,.5,0h0a.35.35,0,0,0,0-.49h0a.37.37,0,0,0-.5,0h0a.37.37,0,0,0,0,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M54.21,21.92h0a.36.36,0,0,0,.49,0h0a.35.35,0,0,0,0-.5.34.34,0,0,0-.48,0l0,0h0a.35.35,0,0,0,0,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M53.19,21.09h0a.36.36,0,0,0,.49-.07h0a.35.35,0,1,0-.53-.42h0a.36.36,0,0,0,.07.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M52.13,20.34h0a.34.34,0,0,0,.48-.1h0a.34.34,0,0,0-.09-.48h0a.35.35,0,0,0-.48.1.34.34,0,0,0,.1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M51,19.66h0a.36.36,0,0,0,.48-.13h0a.35.35,0,0,0-.61-.36h0A.37.37,0,0,0,51,19.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M49.85,19.05h0a.36.36,0,0,0,.46-.16h0a.35.35,0,0,0-.17-.47.34.34,0,0,0-.46.17.35.35,0,0,0,.16.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M48.64,18.52h0a.37.37,0,0,0,.46-.19h0a.37.37,0,0,0-.19-.47h0a.34.34,0,0,0-.45.19h0A.37.37,0,0,0,48.64,18.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M47.43,18.06a.35.35,0,0,0,.44-.21h0a.33.33,0,0,0-.21-.44h0a.35.35,0,0,0-.44.22h0A.35.35,0,0,0,47.43,18.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M46.18,17.69a.37.37,0,0,0,.43-.25h0a.34.34,0,0,0-.23-.42h0a.35.35,0,0,0-.42.26A.36.36,0,0,0,46.18,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M43.62,17.18a.33.33,0,0,0,.38-.29h0a.36.36,0,0,0-.29-.41h0a.36.36,0,0,0-.39.31h0a.35.35,0,0,0,.3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M42.29,17.06a.35.35,0,0,0,.37-.33h0a.34.34,0,0,0-.3-.37h0a.36.36,0,0,0-.32.39A.34.34,0,0,0,42.29,17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M41,17h0a.35.35,0,0,0,.35-.35h0a.35.35,0,0,0-.35-.35h0a.33.33,0,0,0-.35.33v0A.35.35,0,0,0,41,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M39.7,17.06a.33.33,0,0,0,.32-.35h0a.34.34,0,0,0-.36-.34h0a.36.36,0,0,0-.32.38h0a.34.34,0,0,0,.36.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M38.4,17.2a.37.37,0,0,0,.3-.4h0a.34.34,0,0,0-.38-.3h0a.37.37,0,0,0-.29.4A.36.36,0,0,0,38.4,17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M37.11,17.42h0a.36.36,0,0,0,.25-.44.35.35,0,0,0-.39-.26h0a.35.35,0,0,0-.27.41A.37.37,0,0,0,37.11,17.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M35.84,17.71h0a.36.36,0,0,0,.25-.42h0a.37.37,0,0,0-.44-.26.36.36,0,0,0-.24.43A.37.37,0,0,0,35.84,17.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M34.58,18.09h0a.35.35,0,0,0,.22-.44h0a.35.35,0,0,0-.44-.23h0a.35.35,0,0,0-.22.45.34.34,0,0,0,.44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M33.17,19.22h0a.35.35,0,0,0,.45-.19h0a.35.35,0,0,0-.2-.46.35.35,0,0,0-.45.19h0A.35.35,0,0,0,33.17,19.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M32.67,20.45h0a.36.36,0,0,0,.46-.2h0a.33.33,0,0,0-.18-.43h0a.35.35,0,0,0-.46.2h0a.33.33,0,0,0,.19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M32.24,21.72a.35.35,0,0,0,.44-.22h0a.35.35,0,0,0-.22-.44h0a.34.34,0,0,0-.44.21h0a.34.34,0,0,0,.22.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M32.29,22.75h0a.34.34,0,0,0-.22-.43h0a.36.36,0,0,0-.44.24.34.34,0,0,0,.23.43h0A.35.35,0,0,0,32.29,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M31.54,24.28h0A.34.34,0,0,0,32,24h0a.34.34,0,0,0-.26-.42h0a.34.34,0,0,0-.43.24.35.35,0,0,0,.24.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M31.26,25.59h0a.35.35,0,0,0,.4-.27h0a.38.38,0,0,0-.27-.42.34.34,0,0,0-.41.24.06.06,0,0,1,0,0A.37.37,0,0,0,31.26,25.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M31,26.9h0a.35.35,0,0,0,.41-.29h0a.35.35,0,0,0-.28-.4h0a.36.36,0,0,0-.41.29h0a.35.35,0,0,0,.28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M30.88,28.22h0a.36.36,0,0,0,.39-.31h0a.37.37,0,0,0-.32-.38.34.34,0,0,0-.38.3h0a.35.35,0,0,0,.31.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M30.79,29.55h0a.33.33,0,0,0,.35-.31v0h0a.34.34,0,0,0-.31-.37h0a.36.36,0,0,0-.38.33.36.36,0,0,0,.34.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M30.76,30.88a.36.36,0,0,0,.36-.35h0a.35.35,0,0,0-.34-.35h0a.37.37,0,0,0-.36.35h0a.35.35,0,0,0,.34.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M30.82,32.21h0a.34.34,0,0,0,.32-.36h0a.36.36,0,0,0-.37-.34h0a.35.35,0,0,0-.33.36h0a.35.35,0,0,0,.37.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M31.23,33.16a.33.33,0,0,0-.37-.31h0a.35.35,0,0,0-.33.37h0a.37.37,0,0,0,.4.31A.34.34,0,0,0,31.23,33.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M31.11,34.86h0a.37.37,0,0,0,.3-.41h0a.35.35,0,1,0-.69.12.35.35,0,0,0,.38.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M31.39,36.16a.35.35,0,0,0,.27-.41.36.36,0,0,0-.42-.27.34.34,0,0,0-.27.41h0a.34.34,0,0,0,.41.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M32,37h0a.36.36,0,0,0-.43-.24h0a.33.33,0,0,0-.25.4v0h0a.35.35,0,0,0,.44.24h0A.34.34,0,0,0,32,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M32.8,39.51h0a.36.36,0,0,0-.46-.2.36.36,0,0,0-.2.46.35.35,0,0,0,.44.2h0A.36.36,0,0,0,32.8,39.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M33.3,40.71h0a.36.36,0,0,0-.47-.17h0a.35.35,0,1,0,.29.63h0A.36.36,0,0,0,33.3,40.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M33.89,41.89h0a.36.36,0,0,0-.48-.14.35.35,0,0,0-.15.46h0a.35.35,0,0,0,.47.15h0A.36.36,0,0,0,33.89,41.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M34.53,43.05h0a.37.37,0,0,0-.48-.12h0a.34.34,0,0,0-.14.46v0a.37.37,0,0,0,.49.12h0a.35.35,0,0,0,.12-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M34.74,44.06a.37.37,0,0,0-.12.49h0a.37.37,0,0,0,.49.09h0a.35.35,0,1,0-.38-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M35.94,45.25h0a.35.35,0,0,0-.48-.08h0a.35.35,0,0,0-.08.49.33.33,0,0,0,.47.09h0a.35.35,0,0,0,.09-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M36.76,46.3h0a.35.35,0,1,0-.62.32.31.31,0,0,0,.09.11h0a.34.34,0,0,0,.47.07h0a.35.35,0,0,0,.06-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M37.6,47.31h0a.35.35,0,0,0-.49,0,.34.34,0,0,0,0,.49.36.36,0,0,0,.49,0h0a.36.36,0,0,0,0-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M38,48.28a.34.34,0,0,0,0,.49h0a.34.34,0,0,0,.48,0v0a.35.35,0,0,0,0-.5.36.36,0,0,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M39.39,49.21a.35.35,0,0,0-.5.5h0a.34.34,0,0,0,.49,0h0a.34.34,0,0,0,0-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M39.85,50.17h0a.37.37,0,0,0,0,.5h0a.37.37,0,0,0,.5,0h0a.36.36,0,0,0,0-.5.35.35,0,0,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M41.34,51a.36.36,0,0,0-.5,0h0a.34.34,0,0,0,0,.48h0a.35.35,0,0,0,.49,0h0a.34.34,0,0,0,0-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M41.86,51.92a.34.34,0,1,0,.47-.05h0A.35.35,0,0,0,41.86,51.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M42.91,52.74h0a.34.34,0,0,0,.07.49h0a.35.35,0,0,0,.49-.08h0a.35.35,0,1,0-.56-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M44,53.53a.35.35,0,0,0,.08.49h0a.35.35,0,0,0,.49-.09h0a.35.35,0,0,0-.09-.49A.34.34,0,0,0,44,53.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M45.57,54.17a.35.35,0,0,0-.48.1h0a.35.35,0,0,0,.08.47h0a.35.35,0,0,0,.47-.12h0A.34.34,0,0,0,45.57,54.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M46.69,54.86a.34.34,0,0,0-.47.13h0a.34.34,0,0,0,.11.48h0a.33.33,0,0,0,.47-.12h0a.35.35,0,0,0-.11-.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "33.77 18.01 33.77 18.01 33.77 18.01 33.77 18.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "48.32 56.55 48.33 56.55 48.34 56.56 48.34 56.56 48.32 56.55 48.32 56.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "28.47 68.77 39.04 65.56 39.11 65.75 28.55 68.97 28.47 68.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "27.7 65.61 37.69 62.38 37.76 62.58 27.78 65.81 27.7 65.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "27.39 62.74 35.96 59.91 36.03 60.11 27.47 62.94 27.39 62.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "27.58 60.45 34.2 58.09 34.28 58.29 27.66 60.65 27.58 60.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "27.91 58.31 32.47 56.56 32.55 56.75 27.99 58.52 27.91 58.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "30.72 55.32 30.76 55.53 28.37 56.3 28.32 56.09 30.72 55.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "30.25 51.38 30.34 51.58 26.17 53.84 26.09 53.64 30.25 51.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "30.34 48.95 30.42 49.15 24.42 52.21 24.34 52.02 30.34 48.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "29.96 46.03 30.04 46.23 22.67 50.14 22.59 49.94 29.96 46.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "29 42.8 29.08 43 21 47.44 20.91 47.24 29 42.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "27.64 39.63 27.72 39.83 19.64 44.27 19.55 44.07 27.64 39.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "25.96 36.93 26.04 37.13 18.67 41.03 18.59 40.83 25.96 36.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "24.24 34.84 24.32 35.04 18.23 37.97 18.14 37.77 24.24 34.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "22.46 33.23 22.54 33.42 18.22 35.63 18.14 35.43 22.46 33.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "20.53 32.02 20.61 32.22 18.43 33.26 18.35 33.06 20.53 32.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "16.08 30.31 20.64 28.55 20.72 28.75 16.16 30.51 16.08 30.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "14.35 28.77 20.97 26.42 21.04 26.62 14.42 28.97 14.35 28.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "12.59 26.95 21.23 24.1 21.31 24.3 12.67 27.15 12.59 26.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "10.87 24.48 20.85 21.25 20.93 21.45 10.95 24.69 10.87 24.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "9.51 21.31 20.08 18.09 20.15 18.29 9.59 21.51 9.51 21.31"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-110",
    cx: 39.04,
    cy: 65.55,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-111",
    cx: 37.72,
    cy: 62.46,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 27.44,
    cy: 62.88,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-113",
    cx: 36,
    cy: 60.01,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 34.2,
    cy: 58.07,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-115",
    cx: 27.58,
    cy: 60.45,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 32.59,
    cy: 56.6,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-117",
    cx: 27.91,
    cy: 58.32,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 30.6,
    cy: 55.39,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 28.26,
    cy: 56.24,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 28.78,
    cy: 54.08,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-121",
    cx: 30.2,
    cy: 51.48,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 30.37,
    cy: 48.94,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 29.96,
    cy: 46.03,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 29.04,
    cy: 42.88,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 27.76,
    cy: 39.67,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-126",
    cx: 18.64,
    cy: 40.96,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-127",
    cx: 26.02,
    cy: 37.06,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128",
    cx: 18.31,
    cy: 37.83,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-129",
    cx: 24.34,
    cy: 34.95,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 22.4,
    cy: 33.34,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-131",
    cx: 18.2,
    cy: 35.47,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 18.28,
    cy: 33.15,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 20.67,
    cy: 31.96,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 20.69,
    cy: 28.77,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 20.99,
    cy: 26.47,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 14.5,
    cy: 28.83,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 12.64,
    cy: 27.07,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 21.26,
    cy: 24.19,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-139",
    cx: 21.07,
    cy: 21.39,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 10.91,
    cy: 24.61,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 20.53,
    cy: 18.15,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 9.17,
    cy: 21.64,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 16.19,
    cy: 30.41,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-144",
    cx: 18.85,
    cy: 31.08,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 19.71,
    cy: 44.23,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-146",
    cx: 20.94,
    cy: 47.31,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-147",
    cx: 22.67,
    cy: 50.14,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 26.1,
    cy: 53.77,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 24.4,
    cy: 52.15,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 27.77,
    cy: 65.78,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-151",
    cx: 28.6,
    cy: 68.88,
    r: 0.77
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1.87,92.51l-.61,0-.65,0L0,92.37V85.15c.2-.05.42-.08.65-.12L1.36,85q.36,0,.72,0a5.17,5.17,0,0,1,1.66.22,1.81,1.81,0,0,1,1,.66A2,2,0,0,1,5,87a1.87,1.87,0,0,1-.14.76,1.54,1.54,0,0,1-1.16.92v-.06a1.9,1.9,0,0,1,1.11.55,1.78,1.78,0,0,1,.4,1.24A2.06,2.06,0,0,1,5,91.3a1.67,1.67,0,0,1-.6.67,3,3,0,0,1-1,.4A7.43,7.43,0,0,1,1.87,92.51Zm.39-1.15a3.2,3.2,0,0,0,.92-.11.88.88,0,0,0,.49-.35,1,1,0,0,0,.16-.6.94.94,0,0,0-.33-.8,1.69,1.69,0,0,0-1.06-.26H1.3V88.05h1a2.33,2.33,0,0,0,.79-.11.76.76,0,0,0,.42-.33,1.12,1.12,0,0,0,.12-.55.88.88,0,0,0-.3-.75,1.71,1.71,0,0,0-1-.23l-.45,0-.42.05v5.17l.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M6.55,86.15a1,1,0,0,1-.69-.22.91.91,0,0,1,0-1.21,1,1,0,0,1,.69-.22,1,1,0,0,1,.69.22.82.82,0,0,1,.22.61.81.81,0,0,1-.22.6A1,1,0,0,1,6.55,86.15Zm-.73,6.27V87H7.28v5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M10.22,92.53A2.41,2.41,0,0,1,9,92.23a1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63A1.84,1.84,0,0,1,9,87.17a2.39,2.39,0,0,1,1.23-.3,2.39,2.39,0,0,1,1.23.3,2,2,0,0,1,.78.94,3.85,3.85,0,0,1,.27,1.59,3.89,3.89,0,0,1-.27,1.61,1.87,1.87,0,0,1-.77.92A2.42,2.42,0,0,1,10.22,92.53Zm0-1.1a.69.69,0,0,0,.43-.13.87.87,0,0,0,.27-.51A4.76,4.76,0,0,0,11,89.72a5.13,5.13,0,0,0-.09-1.1.94.94,0,0,0-.27-.52.69.69,0,0,0-.43-.14.68.68,0,0,0-.42.14.94.94,0,0,0-.28.51,5,5,0,0,0-.09,1.09,4.92,4.92,0,0,0,.09,1.08,1.09,1.09,0,0,0,.27.52A.69.69,0,0,0,10.22,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M13.17,92.42V87h1.21l.11.58h.06a1.6,1.6,0,0,1,.61-.49,1.58,1.58,0,0,1,.76-.17,1.7,1.7,0,0,1,.79.18,1.3,1.3,0,0,1,.55.6,2.72,2.72,0,0,1,.2,1.13v3.64H16V88.89a.76.76,0,0,0-.16-.57.63.63,0,0,0-.43-.16,1,1,0,0,0-.29,0,.84.84,0,0,0-.27.13,1,1,0,0,0-.23.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M19.57,92.52a1.49,1.49,0,0,1-1.1-.42A1.55,1.55,0,0,1,18,91a1.58,1.58,0,0,1,.48-1.22,2.59,2.59,0,0,1,1.54-.52l.88-.07.2.85-.91.07a.87.87,0,0,0-.57.22.8.8,0,0,0,0,1,.61.61,0,0,0,.45.16.88.88,0,0,0,.34-.08.82.82,0,0,0,.33-.27V89a1.25,1.25,0,0,0-.1-.56.63.63,0,0,0-.33-.29,2,2,0,0,0-.61-.08,3.52,3.52,0,0,0-.62,0,4.54,4.54,0,0,0-.66.14V87.06a5.42,5.42,0,0,1,.76-.14,7.63,7.63,0,0,1,.8,0,3.29,3.29,0,0,1,1.23.2,1.44,1.44,0,0,1,.72.68A3.05,3.05,0,0,1,22.17,89v3.39H21l-.1-.57h-.07a1.19,1.19,0,0,1-.52.52A1.66,1.66,0,0,1,19.57,92.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M23,92.42V87h1.21l.11.58h.06a1.69,1.69,0,0,1,1.37-.66,1.7,1.7,0,0,1,.79.18,1.3,1.3,0,0,1,.55.6,2.72,2.72,0,0,1,.2,1.13v3.64H25.85V88.89a.76.76,0,0,0-.16-.57.64.64,0,0,0-.44-.16,1,1,0,0,0-.28,0,.84.84,0,0,0-.27.13,1,1,0,0,0-.23.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M30.22,92.53a2.39,2.39,0,0,1-1.23-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.67,2.67,0,0,1,2.46,0,2,2,0,0,1,.78.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,30.22,92.53Zm0-1.1a.69.69,0,0,0,.43-.13.87.87,0,0,0,.27-.51A4.76,4.76,0,0,0,31,89.72a5.13,5.13,0,0,0-.09-1.1,1,1,0,0,0-.27-.52.69.69,0,0,0-.43-.14.68.68,0,0,0-.42.14.94.94,0,0,0-.28.51,5,5,0,0,0-.09,1.09,4.92,4.92,0,0,0,.09,1.08,1.09,1.09,0,0,0,.27.52A.69.69,0,0,0,30.22,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M32.54,88.1V87H36V88.1Zm2.65,4.42a1.91,1.91,0,0,1-1.37-.47,2.07,2.07,0,0,1-.49-1.54V87L33.6,85h1.19v5.32a1.13,1.13,0,0,0,.18.73.77.77,0,0,0,.6.2h.24l.26,0v1.19a3.32,3.32,0,0,1-.41.08A3.71,3.71,0,0,1,35.19,92.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M38.94,92.53a3.42,3.42,0,0,1-1.5-.29,1.78,1.78,0,0,1-.85-.92,4.22,4.22,0,0,1-.28-1.65,4,4,0,0,1,.27-1.56,1.91,1.91,0,0,1,.76-.93,2.18,2.18,0,0,1,1.19-.31,1.93,1.93,0,0,1,1.13.31,1.9,1.9,0,0,1,.7.94,4.78,4.78,0,0,1,.23,1.59v.43H37.38v-.9h2.06l-.21.09a4.38,4.38,0,0,0-.08-.93.74.74,0,0,0-.24-.44.55.55,0,0,0-.38-.13.62.62,0,0,0-.4.13.8.8,0,0,0-.25.44,3.72,3.72,0,0,0-.09.93V90a2.29,2.29,0,0,0,.13.83.79.79,0,0,0,.41.43,2.15,2.15,0,0,0,.79.12,4,4,0,0,0,.59,0c.2,0,.4-.08.62-.14v1.17a5.22,5.22,0,0,1-.71.14A5.06,5.06,0,0,1,38.94,92.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M43.39,92.53a2.67,2.67,0,0,1-1.31-.3,1.86,1.86,0,0,1-.82-.92A3.9,3.9,0,0,1,41,89.69a3.48,3.48,0,0,1,.32-1.63,1.94,1.94,0,0,1,.9-.91,3.13,3.13,0,0,1,1.39-.28l.5,0,.47.07v1.2a2.25,2.25,0,0,0-.36-.06h-.34a1.73,1.73,0,0,0-.77.15.94.94,0,0,0-.45.49,2.62,2.62,0,0,0-.14.94,2.93,2.93,0,0,0,.13,1,.94.94,0,0,0,.41.5,1.36,1.36,0,0,0,.67.14,1.87,1.87,0,0,0,.4,0,2.16,2.16,0,0,0,.45-.12v1.2a2.89,2.89,0,0,1-.58.14A4,4,0,0,1,43.39,92.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M45.18,92.42V84.34h1.45v3.19h.07a1.68,1.68,0,0,1,.54-.49,1.65,1.65,0,0,1,.77-.17,1.49,1.49,0,0,1,.73.18,1.26,1.26,0,0,1,.53.6,2.74,2.74,0,0,1,.2,1.14v3.63H48V88.91a.79.79,0,0,0-.16-.58.6.6,0,0,0-.44-.16.93.93,0,0,0-.27,0,.79.79,0,0,0-.28.13,1,1,0,0,0-.23.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M50.32,92.42V87h1.21l.11.58h.06a1.69,1.69,0,0,1,1.37-.66,1.73,1.73,0,0,1,.79.18,1.3,1.3,0,0,1,.55.6,2.72,2.72,0,0,1,.2,1.13v3.64H53.15V88.89a.76.76,0,0,0-.16-.57.64.64,0,0,0-.44-.16,1,1,0,0,0-.28,0,.84.84,0,0,0-.27.13,1,1,0,0,0-.23.23v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M57.52,92.53a2.39,2.39,0,0,1-1.23-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.67,2.67,0,0,1,2.46,0,2,2,0,0,1,.78.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,57.52,92.53Zm0-1.1A.69.69,0,0,0,58,91.3a.87.87,0,0,0,.27-.51,4.76,4.76,0,0,0,.09-1.07,5.13,5.13,0,0,0-.09-1.1A1,1,0,0,0,58,88.1a.69.69,0,0,0-.43-.14.66.66,0,0,0-.42.14.94.94,0,0,0-.28.51,5,5,0,0,0-.09,1.09,4.92,4.92,0,0,0,.09,1.08,1.09,1.09,0,0,0,.27.52A.69.69,0,0,0,57.52,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M60.5,92.42V84.34H62v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M64.9,92.53a2.39,2.39,0,0,1-1.23-.3,1.86,1.86,0,0,1-.78-.91,4.08,4.08,0,0,1-.27-1.6,4.2,4.2,0,0,1,.27-1.63,1.84,1.84,0,0,1,.78-.92,2.67,2.67,0,0,1,2.46,0,2,2,0,0,1,.78.94,4.88,4.88,0,0,1,0,3.2,1.84,1.84,0,0,1-.78.92A2.39,2.39,0,0,1,64.9,92.53Zm0-1.1a.69.69,0,0,0,.43-.13.87.87,0,0,0,.27-.51,4.76,4.76,0,0,0,.09-1.07,5.13,5.13,0,0,0-.09-1.1,1,1,0,0,0-.27-.52A.69.69,0,0,0,64.9,88a.66.66,0,0,0-.42.14.94.94,0,0,0-.28.51,5,5,0,0,0-.09,1.09,4.92,4.92,0,0,0,.09,1.08,1.09,1.09,0,0,0,.27.52A.69.69,0,0,0,64.9,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M69.55,94.72a6.41,6.41,0,0,1-.73,0,5.27,5.27,0,0,1-.75-.14V93.37q.34.09.69.15a4.87,4.87,0,0,0,.66,0,1.42,1.42,0,0,0,1-.28,1.33,1.33,0,0,0,.33-1v-.41h-.07a1.13,1.13,0,0,1-.46.46,1.26,1.26,0,0,1-.69.17,1.6,1.6,0,0,1-.86-.26,2,2,0,0,1-.68-.86,4,4,0,0,1-.26-1.57,3.17,3.17,0,0,1,.66-2.18,2.64,2.64,0,0,1,2.07-.74q.3,0,.6,0a3.76,3.76,0,0,1,.6.1,4,4,0,0,1,.55.15V92a2.31,2.31,0,0,1-2.63,2.71Zm.56-3.45a1,1,0,0,0,.34-.07.68.68,0,0,0,.27-.2V88l-.2,0h-.21a1,1,0,0,0-.83.36,2.16,2.16,0,0,0-.29,1.31,3.58,3.58,0,0,0,.11,1,.77.77,0,0,0,.32.48A.85.85,0,0,0,70.11,91.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M74.1,92.42,72.55,87h1.5l1.34,5.47Zm-.16,2.2.63-2.2L75,91.26,76.1,87h1.45l-2.19,7.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic2);
export default __webpack_public_path__ + "static/media/topic_2.e0e470d1a911eff914a98fc04f7994cb.svg";
export { ForwardRef as ReactComponent };